<template>
    <div class="form-group mod">
        <label :for="id" class="form-label" :class="{ require: required }">
            {{ title }}
        </label>
        <div style="position: relative;">
            <input
                type="text"
                class="form-control"
                :id="id"
                :class="{ 'text-uppercase': uppercase, inValid: isValidate === false }"
                :placeholder="placeholder"
                :disabled="disabled"
                :autocomplete="autocomplete"
                v-model="componentValue"
                @input="doInput"
            />
            <div class="input-loading loading-animate" v-if="isFetching && componentValue"></div>
            <div class="input-close" v-if="!isFetching && componentValue" @click="clearValue">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                        fill="#6F7287"
                    />
                </svg>
            </div>
        </div>
        <p
            class="m-d-0 m-t-4 f-14 f-regular"
            :class="{ inValid: isValidate === false, valid: isValidate === true }"
            v-if="msgVoucher"
        >
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="isValidate === false"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6666 11.3545H1.37995H1.33329C1.12088 11.3435 0.914182 11.2819 0.730439 11.1748C0.546695 11.0677 0.391241 10.9182 0.277055 10.7387C0.16287 10.5593 0.0932656 10.3552 0.0740543 10.1433C0.054843 9.93152 0.0865818 9.71818 0.166621 9.52113L4.83329 1.35446C4.94859 1.14606 5.11762 0.972349 5.32279 0.851386C5.52796 0.730424 5.76178 0.666626 5.99995 0.666626C6.23813 0.666626 6.47195 0.730424 6.67712 0.851386C6.88229 0.972349 7.05132 1.14606 7.16662 1.35446L11.8333 9.52113C11.9133 9.71818 11.9451 9.93152 11.9259 10.1433C11.9066 10.3552 11.837 10.5593 11.7229 10.7387C11.6087 10.9182 11.4532 11.0677 11.2695 11.1748C11.0857 11.2819 10.879 11.3435 10.6666 11.3545ZM6.66659 4.68777C6.66659 4.31958 6.36811 4.0211 5.99992 4.0211C5.63173 4.0211 5.33325 4.31958 5.33325 4.68777V6.0211C5.33325 6.3893 5.63173 6.68777 5.99992 6.68777C6.36811 6.68777 6.66659 6.3893 6.66659 6.0211V4.68777ZM6.66659 8.68777C6.66659 8.31958 6.36811 8.0211 5.99992 8.0211C5.63173 8.0211 5.33325 8.31958 5.33325 8.68777V8.69444C5.33325 9.06263 5.63173 9.3611 5.99992 9.3611C6.36811 9.3611 6.66659 9.06263 6.66659 8.69444V8.68777Z"
                    fill="#DA1E28"
                />
            </svg>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM8.47141 5.13809C8.73175 4.87774 8.73175 4.45563 8.4714 4.19528C8.21105 3.93493 7.78894 3.93493 7.52859 4.19528L5.33333 6.39055L4.47141 5.52862C4.21106 5.26827 3.78895 5.26827 3.5286 5.52862C3.26825 5.78896 3.26825 6.21107 3.5286 6.47143L4.86193 7.80476C4.98695 7.92978 5.15652 8.00002 5.33333 8.00002C5.51014 8.00002 5.67971 7.92978 5.80474 7.80476L8.47141 5.13809Z"
                    fill="#24A148"
                />
            </svg>

            {{ msgVoucher }}
        </p>
    </div>
</template>

<script>
import { regex } from "@/store/utils/vars";

export default {
    name: "SOInputVoucher",
    props: {
        title: String,
        id: {
            type: String,
            default: "kode-voucher",
        },
        placeholder: String,
        value: {
            type: String,
            default: "",
        },
        validation: {
            type: String,
            default: "alphanumeric",
        },
        required: {
            type: Boolean,
            default: false,
        },
        uppercase: {
            type: Boolean,
            default: true,
        },
        isValidate: {
            type: Boolean,
        },
        msgVoucher: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: String,
            default: "off", // on || off
        },
        callbackSearch: {
            type: Function,
            required: true,
        },
        isFetching: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            componentValue: "",
            regexType: {
                default: regex.default,
                alphanumeric: regex.alphanumeric,
                email: regex.email,
                emoji: regex.emoji,
            },
            debounce: null,
        };
    },
    watch: {
        value: {
            handler: function() {
                this.doRegex();
            },
        },
    },
    mounted() {
        this.doRegex();
    },
    methods: {
        doRegex() {
            let regexType = this.regexType[this.validation];
            this.componentValue = this.value.replace(regexType, "");
            this.componentValue = this.componentValue.replace(this.regexType.emoji, "");
            if (this.uppercase) {
                this.componentValue = this.componentValue.toUpperCase();
            }

            this.$emit("input", this.componentValue);
        },
        doInput(val) {
            let that = this;
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                let value = val.target.value;
                if (this.uppercase) {
                    value = value.toUpperCase();
                    if (value !== "") {
                        that.callbackSearch({ kode: value });
                    }
                    that.$emit("input", value);
                }
            }, 500);
        },
        clearValue() {
            this.componentValue = "";
            this.$emit("input", this.componentValue);
        },
    },
};
</script>
<style scoped>
.inValid {
    color: #da1e28;
    border-color: #da1e28 !important;
}
.valid {
    color: #24a148;
}
.input-close,
.input-loading {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 12px;
    right: 4px;
}
.loading-animate {
    top: 7px;
    border: 3px solid #ededed;
    border-top-color: grey;
    border-radius: 50%;
    animation: inputLoading 1s linear infinite;
}

@keyframes inputLoading {
    to {
        transform: rotate(1turn);
    }
}
</style>
